export const removeSpecialCharacters = (text) =>
  text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const stringMatches = (stringValue, data) =>
  data.reduce((acc, text) => {
    const normalizedText = (term) =>
      removeSpecialCharacters(term).toLowerCase();
    const normalizedStringValue =
      removeSpecialCharacters(stringValue).toLowerCase();

    if (
      removeSpecialCharacters(text).match(
        stringValue.replace(/[^\w\s]/gi, '').toLowerCase()
      )?.['0'] === normalizedStringValue
    ) {
      const searchTerm = normalizedText(stringValue)
        .toLowerCase()
        .split('')
        .reduce((termAcc, str) => {
          termAcc.push(str.substring(0, stringValue.length));

          return termAcc;
        }, [])
        ?.join('');

      const componseSearchValue = () => {
        const index = text.indexOf(searchTerm);
        const autoCompleteItem =
          normalizedText(text).indexOf(searchTerm) !== 0
            ? `${text.substring(0, index)}<b>${searchTerm}</b>${text.substring(
                index + searchTerm.length
              )}`
            : `<b>${searchTerm}</b>${text.substring(
                searchTerm.replace(/<\/?[^>]+(>|$)/g, '').length
              )}`;

        return autoCompleteItem;
      };

      if (searchTerm) {
        acc.push({
          searchValue: componseSearchValue(),
          value: text,
        });
      }
    }

    return acc;
  }, []);

export const toNormalizedASCIIStr = (str) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const skipRegexTokensFromStr = (str) => {
  const tokens = [
    '(',
    ')',
    '*',
    '+',
    '/',
    '^',
    '$',
    '\\',
    '[',
    ']',
    '.',
    '?',
    '|',
  ];

  return str
    .split('')
    .map((letter) => (tokens.includes(letter) ? `\\${letter}` : letter))
    .join('');
};
